module.exports = __webpack_public_path__ + "static/media/equities.a5d73fe8.png";